import * as React from 'react';

import GroupAvatar from 'groups/components/GroupAvatar';
import { Props as GroupAvatarProps } from 'groups/components/GroupAvatar';

import getField, { Field } from '../ComposableTableField';

export function getGroupAvatarCellGenerator<T>(
  fieldForAction: Field<T>,
  onClickAction?: (event: React.SyntheticEvent, row: T) => void,
  groupAvatarProps?: Partial<GroupAvatarProps>
) {
  return (data: T) => {
    return (
      <GroupAvatar
        {...groupAvatarProps}
        group={getField(data, fieldForAction)}
        size="small"
        onClick={(e: React.SyntheticEvent) =>
          onClickAction && onClickAction(e, getField(data, fieldForAction))
        }
      />
    );
  };
}
